// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.review-video-player {
  --review-chrome-bg: rgba(0, 0, 0, 0.28);
  --review-btn-bg: rgba(255, 255, 255, 0.12);
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #000;
  overflow: hidden;
  isolation: isolate;
  -webkit-tap-highlight-color: transparent;
}

.review-video-player--fullscreen {
  position: absolute;
  inset: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
}

.review-video-player--embedded {
  border-radius: 12px;
  min-height: 220px;
}

.review-video-player__viewport {
  position: relative;
  z-index: 0;
  flex: 1 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #000;
  /* Touch + trackpad pinch/pan (wheel listeners need non-browser scroll). */
  touch-action: none;
  overscroll-behavior: contain;
}

/* Calibration: hide chrome; keep current zoom/pan/orientation locked. */
.review-video-player--calibrating .review-video-player__viewport {
  z-index: 40;
}

.review-video-player--calibrating .review-video-player__chrome {
  display: none !important;
}

/* Video must not steal taps from the corner / ROI draw layer. */
.review-video-player--calibrating .review-video-player__video {
  pointer-events: none !important;
}

.review-video-player--fullscreen .review-video-player__viewport {
  height: auto;
  flex: 1 1 auto;
}

.review-video-player--embedded .review-video-player__viewport {
  aspect-ratio: 16 / 9;
  max-height: 360px;
}

.review-video-player__transform {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: center center;
  will-change: transform;
}

.review-video-player__video {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  background: #000;
  transform-origin: center center;
}

.review-video-player--view-pending .review-video-player__transform,
.review-video-player--view-pending .review-video-player__video {
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
}

.review-video-player__view-loading {
  position: absolute;
  inset: 0;
  z-index: 40;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #000;
  color: rgba(255, 255, 255, 0.92);
  pointer-events: none;
}

.review-video-player__load-meter {
  width: min(220px, 56vw);
  height: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  overflow: hidden;
}

.review-video-player__load-meter-fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #38bdf8, #a78bfa);
  transition: width 0.25s ease;
}

.review-video-player__load-eta {
  font-size: 0.78rem;
  font-weight: 650;
  color: rgba(248, 250, 252, 0.78);
  font-variant-numeric: tabular-nums;
}

.review-video-player__compat-banner {
  position: absolute;
  top: max(12px, env(safe-area-inset-top, 0px));
  left: 50%;
  transform: translateX(-50%);
  z-index: 35;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: min(92vw, 28rem);
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.82);
  color: rgba(248, 250, 252, 0.95);
  font-size: 12px;
  line-height: 1.3;
  pointer-events: none;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.review-video-player__compat-banner .review-video-player__view-loading-icon {
  width: 16px;
  height: 16px;
  animation: review-video-spin 0.9s linear infinite;
}

.review-video-player__view-loading--error {
  pointer-events: auto;
  padding: 16px 20px;
  text-align: center;
  gap: 14px;
  background: rgba(0, 0, 0, 0.92);
}

.review-video-player__view-loading--error .review-video-player__view-loading-label {
  max-width: 28rem;
  line-height: 1.35;
}

.review-video-player__media-error-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.review-video-player__media-error-btn {
  pointer-events: auto;
  gap: 6px;
}

.review-video-player__view-loading-icon {
  animation: review-video-spin 0.85s linear infinite;
}

.review-video-player__view-loading-label {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.review-video-player__view-loading--buffer {
  background: rgba(0, 0, 0, 0.55);
}

.review-video-player__load-bar {
  width: min(56vw, 14rem);
  height: 6px;
  border-radius: 999px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.18);
}

.review-video-player__load-bar-fill {
  height: 100%;
  width: 0;
  border-radius: inherit;
  background: #38bdf8;
  transition: width 0.35s ease;
}

.review-video-player__load-bar--indeterminate .review-video-player__load-bar-fill {
  width: 36%;
  animation: review-video-load-indeterminate 1.1s ease-in-out infinite;
}

.review-video-player__load-eta {
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.72);
}

@keyframes review-video-load-indeterminate {
  0% {
    transform: translateX(-120%);
  }
  100% {
    transform: translateX(320%);
  }
}

@keyframes review-video-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.review-video-player__chrome {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  background: var(--review-chrome-bg);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

.review-video-player__chrome--top {
  top: 0;
  padding-top: max(12px, env(safe-area-inset-top, 0px));
  /* Gutter for fullscreen back button, now on the left. */
  padding-left: 64px;
  padding-right: 12px;
}

.review-video-player__chrome--bottom {
  bottom: 0;
  padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));
}

.review-video-player--controls-visible .review-video-player__chrome,
.review-video-player__chrome:focus-within {
  opacity: 1;
  /* Keep chrome itself non-interactive so a tap on empty chrome hides UI. */
  pointer-events: none;
}

.review-video-player--controls-visible .review-video-player__chrome button,
.review-video-player--controls-visible .review-video-player__chrome input,
.review-video-player--controls-visible .review-video-player__chrome select,
.review-video-player--controls-visible .review-video-player__pose-tools,
.review-video-player--controls-visible .review-video-player__joint-overlay,
.review-video-player--controls-visible .review-video-player__transport,
.review-video-player--controls-visible .review-video-player__game-points,
.review-video-player__chrome:focus-within button,
.review-video-player__chrome:focus-within input,
.review-video-player__chrome:focus-within select,
.review-video-player--top-collapsed .review-video-player__chrome-toggle {
  pointer-events: auto;
}

.review-video-player--fullscreen:not(.review-video-player--controls-visible) .review-video-player__chrome,
.review-video-player--fullscreen:not(.review-video-player--controls-visible).review-video-player--top-collapsed .review-video-player__chrome--top,
.review-video-player--fullscreen:not(.review-video-player--controls-visible) .review-video-player__analysis-hud {
  opacity: 0 !important;
  pointer-events: none !important;
}

/* Match review basic playback: feedback icon stays tappable on the video. */
.review-video-player.review-video-player--basic.review-video-player--has-feedback:not(.review-video-player--annotating) .review-video-player__analysis-hud {
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: none;
}

.review-video-player--basic {
  container-type: size;
  container-name: review-basic;
}

.review-video-player--basic .review-video-player__chrome--bottom {
  padding: clamp(4px, 1.6cqi, 12px);
  padding-bottom: max(clamp(4px, 1.6cqi, 12px), env(safe-area-inset-bottom, 0px));
}

.review-video-player--basic .review-video-player__transport {
  gap: clamp(4px, 1.2cqi, 8px);
}

.review-video-player--basic .review-video-player__transport-main > .review-video-player__btn,
.review-video-player--basic .review-video-player__btn {
  min-width: clamp(1.8rem, 9cqi, 3.1rem);
  min-height: clamp(1.8rem, 9cqi, 3.1rem);
  border-radius: clamp(8px, 2.4cqi, 14px);
  padding: clamp(2px, 0.8cqi, 6px);
}

.review-video-player--basic .review-video-player__transport-main > .review-video-player__btn--play,
.review-video-player--basic .review-video-player__btn--play {
  min-width: clamp(2.1rem, 11cqi, 3.4rem);
  min-height: clamp(2.1rem, 11cqi, 3.4rem);
}

.review-video-player--basic .review-video-player__btn svg {
  width: clamp(12px, 4.2cqi, 22px);
  height: clamp(12px, 4.2cqi, 22px);
}

.review-video-player--basic .review-video-player__btn span {
  font-size: clamp(8px, 2.1cqi, 11px);
}

.review-video-player--basic .review-video-player__analysis-hud {
  top: clamp(6px, 2cqi, 12px);
  right: clamp(6px, 2cqi, 12px);
  gap: clamp(4px, 1.4cqi, 8px);
  max-width: min(78cqi, 18rem);
}

.review-video-player--basic .review-video-player__analysis-info-btn {
  width: clamp(1.7rem, 8cqi, 2.75rem);
  height: clamp(1.7rem, 8cqi, 2.75rem);
}

.review-video-player--basic .review-video-player__analysis-info-btn svg {
  width: 48%;
  height: 48%;
}

.review-video-player--basic .review-video-player__feedback-blink,
.review-video-player--feedback-on-demand .review-video-player__feedback-blink {
  animation: feedback-icon-blink 1.15s ease-in-out infinite;
}

.review-video-player--basic .review-video-player__feedback-blink.is-on,
.review-video-player--feedback-on-demand .review-video-player__feedback-blink.is-on {
  background: rgba(250, 204, 21, 0.42);
  border-color: rgba(250, 204, 21, 0.9);
}

@keyframes feedback-icon-blink {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(250, 204, 21, 0.75);
  }
  50% {
    box-shadow: 0 0 0 clamp(3px, 1.4cqi, 8px) rgba(250, 204, 21, 0);
  }
}

.review-video-player--basic .review-video-player__feedback-list {
  width: min(72cqi, 16rem);
  max-height: min(46cqi, 14rem);
  overflow: auto;
  padding: clamp(4px, 1.4cqi, 8px);
  border-radius: clamp(8px, 2cqi, 12px);
  background: rgba(15, 23, 42, 0.82);
  pointer-events: auto;
}

.review-video-player--basic .review-video-player__feedback-play {
  font-size: clamp(10px, 2.6cqi, 13px);
}

/* Embedded match review: hide HUD overlays until the coach taps. */
.review-video-player:not(.review-video-player--controls-visible):not(.review-video-player--feedback-review):not(.review-video-player--feedback-recording):not(.review-video-player--annotating) .review-video-player__analysis-hud,
.review-video-player:not(.review-video-player--controls-visible):not(.review-video-player--feedback-review) .review-video-player__chrome {
  opacity: 0 !important;
  pointer-events: none !important;
}

.review-video-player.review-video-player--basic.review-video-player--has-feedback:not(.review-video-player--annotating) .review-video-player__analysis-hud,
.review-video-player.review-video-player--feedback-on-demand.review-video-player--has-feedback:not(.review-video-player--annotating) .review-video-player__analysis-hud {
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: none;
}

.review-video-player--feedback-on-demand.review-video-player--has-feedback .review-video-player__feedback-blink,
.review-video-player--feedback-on-demand.review-video-player--has-feedback .review-video-player__feedback-list {
  pointer-events: auto !important;
}

.review-video-player--fullscreen:not(.review-video-player--controls-visible) .review-video-player__pose-tools,
.review-video-player--fullscreen:not(.review-video-player--controls-visible) .review-video-player__analysis-hud * {
  pointer-events: none !important;
}

.review-video-player--feedback-on-demand.review-video-player--has-feedback .review-video-player__feedback-blink,
.review-video-player--fullscreen.review-video-player--feedback-on-demand.review-video-player--has-feedback .review-video-player__feedback-blink,
.review-video-player--feedback-on-demand.review-video-player--has-feedback .review-video-player__feedback-list,
.review-video-player--feedback-on-demand.review-video-player--has-feedback .review-video-player__feedback-list * {
  pointer-events: auto !important;
}

/* Feedback take: only the review bar stays; hide transport / tools / HUD. */
.review-video-player--feedback-review .review-video-player__chrome,
.review-video-player--feedback-review .review-video-player__analysis-hud {
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
}

.review-video-player--basic.review-video-player--feedback-review.review-video-player--has-feedback .review-video-player__analysis-hud,
.review-video-player--feedback-on-demand.review-video-player--feedback-review.review-video-player--has-feedback .review-video-player__analysis-hud {
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: none;
}

.review-video-player--feedback-review .review-video-player__feedback-mode {
  pointer-events: auto;
  bottom: max(16px, env(safe-area-inset-bottom, 0px));
  gap: 10px;
  padding: 8px 10px 8px 12px;
  max-width: min(96%, 420px);
}

/* Keep pose tools clickable even if chrome visibility flickers */
.review-video-player__pose-tools {
  pointer-events: auto;
}

.review-video-player--embedded .review-video-player__chrome--top {
  padding-right: 100px;
  border-radius: 12px 12px 0 0;
}

.review-video-player__orient {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.review-video-player__chrome-toggle {
  position: absolute;
  top: max(10px, env(safe-area-inset-top, 0px));
  right: 56px;
  z-index: 2;
  min-width: 40px;
  min-height: 40px;
  border-radius: 12px;
  background: rgba(12, 16, 28, 0.72);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.28);
}

.review-video-player--embedded .review-video-player__chrome-toggle {
  right: 52px;
}

.review-video-player--top-collapsed .review-video-player__chrome--top {
  padding: 8px 56px 0 12px;
  min-height: calc(max(10px, env(safe-area-inset-top, 0px)) + 44px);
  background: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  gap: 0;
}

.review-video-player--top-collapsed .review-video-player__orient,
.review-video-player--top-collapsed .review-video-player__pose-tools,
.review-video-player--top-collapsed .review-video-player__orient-status {
  display: none;
}

.review-video-player__orient-status {
  margin: 0;
  text-align: center;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.88);
}

.review-video-player__orient-status--error {
  color: #ffb4b4;
}

.review-video-player__orient-status--ok {
  color: #9be7b5;
}

.review-video-player__speeds {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.review-video-player__speed-btn {
  min-width: 44px;
  height: 30px;
  padding: 0 10px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 999px;
  background: var(--review-btn-bg);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.review-video-player__speed-btn--active {
  background: rgba(255, 255, 255, 0.88);
  color: #111;
  border-color: transparent;
}

.review-video-player__mute-btn {
  min-width: 36px;
  padding: 0 8px;
}

.review-video-player__mute-btn--on {
  background: rgba(255, 255, 255, 0.22);
  border-color: rgba(255, 255, 255, 0.4);
}

.review-video-player__joint-overlay {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.review-video-player__joint-overlay-players {
  display: inline-flex;
  gap: 4px;
  margin-right: 2px;
}

.review-video-player__joint-overlay-btn {
  min-width: 56px;
  height: 28px;
  padding: 0 10px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 999px;
  background: var(--review-btn-bg);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
}

.review-video-player__joint-overlay-players .review-video-player__joint-overlay-btn {
  min-width: 36px;
  padding: 0 8px;
}

.review-video-player__joint-overlay-btn--active {
  background: rgba(255, 255, 255, 0.88);
  color: #111;
  border-color: transparent;
}

.review-video-player__joint-overlay-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.review-video-player__joint-overlay-error {
  flex-basis: 100%;
  margin: 0;
  text-align: center;
  color: #ffb4a9;
  font-size: 11px;
  font-weight: 600;
}

.review-video-player__joint-overlay-error-action {
  display: inline;
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  color: #fff;
  font: inherit;
  font-weight: 800;
  text-decoration: underline;
  cursor: pointer;
}

.review-video-player--transport-locked .review-video-player__chrome--bottom {
  opacity: 1;
}

.review-video-player--transport-locked .review-video-player__chrome--bottom button,
.review-video-player--transport-locked .review-video-player__chrome--bottom input {
  pointer-events: auto;
}

.review-video-player__scrubber-wrap {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}

.review-video-player__scrubber {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 4px;
  margin: 0;
  accent-color: #fff;
  cursor: pointer;
}

.review-video-player__time {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: rgba(255, 255, 255, 0.88);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}

.review-video-player__time-sep {
  opacity: 0.55;
}

.review-video-player__transport {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}

.review-video-player__transport-main {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 6px;
  width: 100%;
}

.review-video-player__transport-main > .review-video-player__btn {
  flex: 1 1;
  min-width: 0;
  min-height: 52px;
  padding: 6px 4px;
  border-radius: 14px;
}

.review-video-player__transport-main > .review-video-player__btn--seek {
  flex: 1.05 1;
}

.review-video-player__transport-main > .review-video-player__btn--frame {
  flex: 0.95 1;
}

.review-video-player__transport-main > .review-video-player__btn--play {
  flex: 1.25 1;
  min-width: 56px;
  min-height: 56px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.22);
}

.review-video-player__transport-extra {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.review-video-player__btn {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-width: 44px;
  min-height: 44px;
  padding: 4px 6px;
  border: none;
  border-radius: 12px;
  background: var(--review-btn-bg);
  color: #fff;
  cursor: pointer;
}

.review-video-player__btn span {
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
  opacity: 0.85;
}

.review-video-player__btn--play {
  min-width: 52px;
  min-height: 52px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
}

.review-video-player__btn--active {
  background: rgba(255, 255, 255, 0.28);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);
}

.review-video-player__btn:active {
  transform: scale(0.96);
}

.review-video-player__ball-detector {
  appearance: none;
  -webkit-appearance: none;
  font-size: 9px;
  font-weight: 700;
  text-align: center;
  padding: 4px 8px;
  max-width: 88px;
}

.review-video-player__ball-stroke {
  appearance: none;
  -webkit-appearance: none;
  font-size: 9px;
  font-weight: 700;
  text-align: center;
  padding: 4px 8px;
  max-width: 118px;
}

.review-video-player__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.review-video-player__reset-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 0 4px;
}

.review-video-player--landscape.review-video-player--fullscreen {
  width: 100%;
  height: 100%;
}

.review-video-player__save-overlay {
  position: absolute;
  inset: 0;
  z-index: 25;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.45);
  pointer-events: auto;
}

.review-video-player__save-card {
  width: min(360px, 100%);
  padding: 16px 18px;
  border-radius: 14px;
  background: rgba(0, 0, 0, 0.62);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  color: #fff;
  text-align: center;
}

.review-video-player__save-title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
}

.review-video-player__reencode-bar {
  margin-top: 12px;
  height: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  overflow: hidden;
}

.review-video-player__reencode-bar-fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #0a84ff, #64d2ff);
  transition: width 0.35s ease;
}

.review-video-player__reencode-meta {
  margin: 8px 0 0;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.82);
}

.review-video-player__hr {
  position: absolute;
  top: max(12px, env(safe-area-inset-top, 0px));
  left: 12px;
  z-index: 18;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 6px 10px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  color: #fff;
  pointer-events: none;
  max-width: min(70vw, 280px);
}

.review-video-player__hr-line {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.review-video-player__hr-name {
  font-size: 11px;
  font-weight: 700;
  opacity: 0.92;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
}

.review-video-player__hr-name::after {
  content: ":";
}

.review-video-player__hr-icon {
  flex-shrink: 0;
  color: #ff5a5f;
}

.review-video-player__hr-value {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.02em;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.review-video-player__hr-unit {
  font-size: 11px;
  font-weight: 600;
  opacity: 0.85;
  text-transform: lowercase;
}

.review-video-player__analysis-hud {
  position: absolute;
  /* Clear the fullscreen back button (44px) so it does not cover Show features. */
  top: calc(max(12px, env(safe-area-inset-top, 0px)) + 72px);
  right: max(12px, env(safe-area-inset-right, 0px));
  left: auto;
  bottom: auto;
  /* Above chrome (20); still inside the player so the close "X" stays on top. */
  z-index: 26;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  max-width: min(86vw, 340px);
  pointer-events: none;
}

.review-video-player__feedback-list {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  max-height: 28vh;
  overflow: auto;
  pointer-events: auto;
}

.review-video-player__feedback-auto {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: min(86vw, 220px);
  margin: 0;
  padding: 6px 8px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: rgba(15, 23, 42, 0.78);
  color: rgba(248, 250, 252, 0.96);
  font-size: 11px;
  font-weight: 650;
  line-height: 1.3;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.review-video-player__feedback-auto input {
  margin: 2px 0 0;
  flex-shrink: 0;
  accent-color: #facc15;
}

.review-video-player__feedback-hint {
  width: min(86vw, 220px);
  margin: 0;
  padding: 0 4px;
  font-size: 10px;
  line-height: 1.35;
  color: rgba(226, 232, 240, 0.78);
  text-align: right;
}

.review-video-player__feedback-chip {
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  border: 1px solid rgba(250, 204, 21, 0.45);
  border-radius: 999px;
  padding: 2px 4px 2px 2px;
  background: rgba(15, 23, 42, 0.82);
  color: #fef9c3;
}

.review-video-player__feedback-play,
.review-video-player__feedback-delete {
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.review-video-player__feedback-play {
  padding: 4px 6px 4px 8px;
  font-size: 11px;
  font-weight: 700;
}

.review-video-player__feedback-delete {
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  border-radius: 999px;
}

.review-video-player__feedback-delete:hover {
  background: rgba(239, 68, 68, 0.85);
  color: #fff;
}

.review-video-player__feedback-chip.is-on {
  background: rgba(250, 204, 21, 0.28);
  color: #fff;
}

.review-video-player__feedback-mode {
  position: absolute;
  top: auto;
  bottom: calc(max(12px, env(safe-area-inset-bottom, 0px)) + 96px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 40;
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 750;
  letter-spacing: 0.02em;
  pointer-events: none;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  max-width: min(96%, 26rem);
}

.review-video-player--annotating .review-video-player__feedback-mode {
  bottom: calc(max(12px, env(safe-area-inset-bottom, 0px)) + 210px);
}

.review-video-player__feedback-mode--rec {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  background: rgba(127, 29, 29, 0.92);
  color: #fecaca;
  border: 1px solid rgba(248, 113, 113, 0.7);
}

.review-video-player__feedback-mode--review {
  background: rgba(120, 53, 15, 0.92);
  color: #fde68a;
  border: 1px solid rgba(250, 204, 21, 0.7);
}

.review-video-player__feedback-mode--review.is-list-open {
  border-radius: 16px;
  padding: 8px 10px;
}

.review-video-player__feedback-mode-bar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
}

.review-video-player__feedback-mode-label {
  white-space: nowrap;
}

.review-video-player__feedback-mode-btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 28px;
  padding: 4px 10px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.45);
  color: inherit;
  font: inherit;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  pointer-events: auto;
}

.review-video-player__feedback-mode-btn.is-on {
  background: rgba(250, 204, 21, 0.28);
  border-color: rgba(250, 204, 21, 0.7);
}

.review-video-player__feedback-mode-btn--icon {
  min-width: 28px;
  padding: 4px 8px;
  position: relative;
}

.review-video-player__feedback-mode-count {
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
}

.review-video-player__feedback-mode-btn--primary {
  background: rgba(250, 204, 21, 0.92);
  border-color: transparent;
  color: #422006;
}

.review-video-player__feedback-mode-btn:active {
  transform: scale(0.97);
}

.review-video-player__feedback-mode-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: min(40vh, 14rem);
  overflow: auto;
  padding: 4px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.55);
  pointer-events: auto;
}

.review-video-player__feedback-mode-item {
  appearance: none;
  display: block;
  width: 100%;
  text-align: left;
  padding: 6px 10px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #fde68a;
  font: inherit;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  pointer-events: auto;
}

.review-video-player__feedback-mode-item:hover,
.review-video-player__feedback-mode-item.is-on {
  background: rgba(250, 204, 21, 0.22);
  border-color: rgba(250, 204, 21, 0.45);
  color: #fff;
}

.review-video-player__feedback-mode-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #ef4444;
  box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);
  animation: feedback-rec-pulse 1.2s ease-out infinite;
}

@keyframes feedback-rec-pulse {
  70% {
    box-shadow: 0 0 0 8px rgba(239, 68, 68, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);
  }
}

.review-video-player--feedback-review {
  box-shadow: inset 0 0 0 3px rgba(250, 204, 21, 0.85);
}

.review-video-player--feedback-recording {
  box-shadow: inset 0 0 0 3px rgba(239, 68, 68, 0.9);
}

.review-video-player__feedback-demo {
  position: absolute;
  z-index: 8;
  right: 12px;
  bottom: 120px;
  width: min(42%, 280px);
  max-height: 36%;
  border-radius: 12px;
  background: #000;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
  pointer-events: none;
}

.review-video-player__analysis-info-btn {
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.32);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.62);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  color: rgba(255, 255, 255, 0.96);
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);
  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    background 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    border-color 0.2s cubic-bezier(0.25, 1, 0.5, 1);
}

.review-video-player__analysis-info-btn svg {
  display: block;
}

.review-video-player__analysis-info-btn:hover {
  transform: scale(1.04);
  background: rgba(15, 23, 42, 0.82);
  border-color: rgba(255, 255, 255, 0.5);
}

.review-video-player__analysis-info-btn:active {
  transform: scale(0.96);
}

.review-video-player__analysis-info-btn.is-on,
.review-video-player__analysis-info-btn[aria-pressed="true"] {
  background: rgba(250, 204, 21, 0.32);
  border-color: rgba(250, 204, 21, 0.85);
  color: #fff;
}

.review-video-player__analysis-info-btn:focus-visible {
  outline: 2px solid rgba(125, 211, 252, 0.95);
  outline-offset: 2px;
}

.review-video-player__analysis-hud--open .review-video-player__analysis-info-btn {
  background: rgba(15, 23, 42, 0.88);
  border-color: rgba(255, 255, 255, 0.5);
}

.review-video-player__analysis-hud-panel {
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: min(72vw, 260px);
  max-width: min(86vw, 340px);
  max-height: min(62vh, 420px);
  overflow: auto;
  padding: 10px 12px 12px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: rgba(15, 23, 42, 0.78);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  color: rgba(248, 250, 252, 0.96);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.38);
  font-family: ui-sans-serif, system-ui, -apple-system, sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.01em;
  line-height: 1.35;
  text-align: left;
}

.review-video-player__analysis-hud-section + .review-video-player__analysis-hud-section {
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.review-video-player__analysis-hud-title {
  margin-bottom: 4px;
  color: rgba(186, 230, 253, 0.95);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.review-video-player__analysis-hud-row {
  display: grid;
  grid-template-columns: minmax(72px, 38%) 1fr;
  gap: 8px;
  align-items: baseline;
}

.review-video-player__analysis-hud-key {
  color: rgba(226, 232, 240, 0.62);
  font-size: 11px;
  font-weight: 600;
}

.review-video-player__analysis-hud-val {
  color: rgba(248, 250, 252, 0.98);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  font-weight: 600;
  text-align: right;
  overflow-wrap: anywhere;
}

.review-video-player__analysis-hud-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.review-video-player__analysis-hud-state {
  margin-top: 2px;
  padding: 1px 6px;
  align-self: flex-end;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.14);
  color: rgba(255, 235, 59, 0.95);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-size: 10px;
}

.review-video-player--embedded .review-video-player__analysis-hud {
  top: max(12px, env(safe-area-inset-top, 0px));
}

.review-video-player__feedback-panel {
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: min(86vw, 220px);
  max-height: min(42vh, 260px);
  overflow: auto;
  padding: 8px 10px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(15, 23, 42, 0.78);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);
  color: rgba(248, 250, 252, 0.96);
}

.review-video-player__feedback-auto {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  font-size: 11px;
  font-weight: 650;
  line-height: 1.3;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.review-video-player__feedback-auto input {
  margin: 2px 0 0;
  flex-shrink: 0;
  accent-color: #38bdf8;
}

.review-video-player__feedback-hint {
  margin: 0;
  font-size: 10px;
  line-height: 1.35;
  color: rgba(226, 232, 240, 0.78);
}

.review-video-player__feedback-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.review-video-player__feedback-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin: 0;
  padding: 6px 8px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.review-video-player__feedback-item:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.32);
}

.review-video-player__feedback-item.is-on {
  background: rgba(56, 189, 248, 0.22);
  border-color: rgba(125, 211, 252, 0.55);
}

.review-video-player__feedback-time {
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  font-size: 11px;
  color: #7dd3fc;
}

.review-video-player__feedback-kind {
  font-size: 11px;
  line-height: 1.25;
  color: rgba(248, 250, 252, 0.92);
}

/* --- viral clip composer modal --- */
.review-video-player__clip-modal {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(8, 11, 16, 0.66);
  backdrop-filter: blur(3px);
  overflow-y: auto;
}

.review-video-player__clip-modal-inner {
  width: min(920px, 100%);
  max-height: 92vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 16px;
  padding: 22px 24px 26px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.4);
}
`, "",{"version":3,"sources":["webpack://./src/components/ReviewVideoPlayer.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,0EAA0E;EAC1E,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,wEAAwE;AACxE;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gEAAgE;AAChE;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;;EAEE,qBAAqB;EACrB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,oEAAoE;AACtE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,0BAA0B;EAC1B,kCAAkC;EAClC,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,MAAM;EACN,qDAAqD;EACrD,wDAAwD;EACxD,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,2DAA2D;AAC7D;;AAEA;;EAEE,UAAU;EACV,0EAA0E;EAC1E,oBAAoB;AACtB;;AAEA;;;;;;;;;;;EAWE,oBAAoB;AACtB;;AAEA;;;EAGE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,4EAA4E;AAC5E;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,+EAA+E;AACjF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,sCAAsC;EACtC,uCAAuC;EACvC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;EAEE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,yDAAyD;AAC3D;;AAEA;;EAEE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE;;IAEE,4CAA4C;EAC9C;EACA;IACE,+DAA+D;EACjE;AACF;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,cAAc;EACd,gCAAgC;EAChC,qCAAqC;EACrC,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mEAAmE;AACnE;;EAEE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;;EAEE,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA,4EAA4E;AAC5E;;EAEE,qBAAqB;EACrB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;;EAEE,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mDAAmD;EACnD,SAAS;EACT,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,iEAAiE;AACjE;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,iEAAiE;EACjE,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,MAAM;AACR;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;EACpB,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;EACpB,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAc;AAChB;;AAEA;EACE,YAAc;AAChB;;AAEA;EACE,YAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;EAClC,WAAW;EACX,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gFAAgF;EAChF,0DAA0D;EAC1D,iDAAiD;EACjD,UAAU;EACV,YAAY;EACZ,8EAA8E;EAC9E,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0CAA0C;EAC1C,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gEAAgE;EAChE,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,oBAAoB;EACpB,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,4BAA4B;EAC5B,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,2CAA2C;EAC3C,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;EACf,0CAA0C;EAC1C;;mDAEiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,2CAA2C;EAC3C,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;AAC5C","sourcesContent":[".review-video-player {\n  --review-chrome-bg: rgba(0, 0, 0, 0.28);\n  --review-btn-bg: rgba(255, 255, 255, 0.12);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background: #000;\n  overflow: hidden;\n  isolation: isolate;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.review-video-player--fullscreen {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  height: 100%;\n  width: 100%;\n}\n\n.review-video-player--embedded {\n  border-radius: 12px;\n  min-height: 220px;\n}\n\n.review-video-player__viewport {\n  position: relative;\n  z-index: 0;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: #000;\n  /* Touch + trackpad pinch/pan (wheel listeners need non-browser scroll). */\n  touch-action: none;\n  overscroll-behavior: contain;\n}\n\n/* Calibration: hide chrome; keep current zoom/pan/orientation locked. */\n.review-video-player--calibrating .review-video-player__viewport {\n  z-index: 40;\n}\n\n.review-video-player--calibrating .review-video-player__chrome {\n  display: none !important;\n}\n\n/* Video must not steal taps from the corner / ROI draw layer. */\n.review-video-player--calibrating .review-video-player__video {\n  pointer-events: none !important;\n}\n\n.review-video-player--fullscreen .review-video-player__viewport {\n  height: auto;\n  flex: 1 1 auto;\n}\n\n.review-video-player--embedded .review-video-player__viewport {\n  aspect-ratio: 16 / 9;\n  max-height: 360px;\n}\n\n.review-video-player__transform {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform-origin: center center;\n  will-change: transform;\n}\n\n.review-video-player__video {\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  background: #000;\n  transform-origin: center center;\n}\n\n.review-video-player--view-pending .review-video-player__transform,\n.review-video-player--view-pending .review-video-player__video {\n  opacity: 0 !important;\n  visibility: hidden !important;\n  pointer-events: none !important;\n}\n\n.review-video-player__view-loading {\n  position: absolute;\n  inset: 0;\n  z-index: 40;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  background: #000;\n  color: rgba(255, 255, 255, 0.92);\n  pointer-events: none;\n}\n\n.review-video-player__load-meter {\n  width: min(220px, 56vw);\n  height: 6px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.16);\n  overflow: hidden;\n}\n\n.review-video-player__load-meter-fill {\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #38bdf8, #a78bfa);\n  transition: width 0.25s ease;\n}\n\n.review-video-player__load-eta {\n  font-size: 0.78rem;\n  font-weight: 650;\n  color: rgba(248, 250, 252, 0.78);\n  font-variant-numeric: tabular-nums;\n}\n\n.review-video-player__compat-banner {\n  position: absolute;\n  top: max(12px, env(safe-area-inset-top, 0px));\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 35;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  max-width: min(92vw, 28rem);\n  padding: 8px 12px;\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.82);\n  color: rgba(248, 250, 252, 0.95);\n  font-size: 12px;\n  line-height: 1.3;\n  pointer-events: none;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.review-video-player__compat-banner .review-video-player__view-loading-icon {\n  width: 16px;\n  height: 16px;\n  animation: review-video-spin 0.9s linear infinite;\n}\n\n.review-video-player__view-loading--error {\n  pointer-events: auto;\n  padding: 16px 20px;\n  text-align: center;\n  gap: 14px;\n  background: rgba(0, 0, 0, 0.92);\n}\n\n.review-video-player__view-loading--error .review-video-player__view-loading-label {\n  max-width: 28rem;\n  line-height: 1.35;\n}\n\n.review-video-player__media-error-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.review-video-player__media-error-btn {\n  pointer-events: auto;\n  gap: 6px;\n}\n\n.review-video-player__view-loading-icon {\n  animation: review-video-spin 0.85s linear infinite;\n}\n\n.review-video-player__view-loading-label {\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n}\n\n.review-video-player__view-loading--buffer {\n  background: rgba(0, 0, 0, 0.55);\n}\n\n.review-video-player__load-bar {\n  width: min(56vw, 14rem);\n  height: 6px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.review-video-player__load-bar-fill {\n  height: 100%;\n  width: 0;\n  border-radius: inherit;\n  background: #38bdf8;\n  transition: width 0.35s ease;\n}\n\n.review-video-player__load-bar--indeterminate .review-video-player__load-bar-fill {\n  width: 36%;\n  animation: review-video-load-indeterminate 1.1s ease-in-out infinite;\n}\n\n.review-video-player__load-eta {\n  font-size: 11px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.72);\n}\n\n@keyframes review-video-load-indeterminate {\n  0% {\n    transform: translateX(-120%);\n  }\n  100% {\n    transform: translateX(320%);\n  }\n}\n\n@keyframes review-video-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.review-video-player__chrome {\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 10px 12px;\n  background: var(--review-chrome-bg);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n}\n\n.review-video-player__chrome--top {\n  top: 0;\n  padding-top: max(12px, env(safe-area-inset-top, 0px));\n  /* Gutter for fullscreen back button, now on the left. */\n  padding-left: 64px;\n  padding-right: 12px;\n}\n\n.review-video-player__chrome--bottom {\n  bottom: 0;\n  padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));\n}\n\n.review-video-player--controls-visible .review-video-player__chrome,\n.review-video-player__chrome:focus-within {\n  opacity: 1;\n  /* Keep chrome itself non-interactive so a tap on empty chrome hides UI. */\n  pointer-events: none;\n}\n\n.review-video-player--controls-visible .review-video-player__chrome button,\n.review-video-player--controls-visible .review-video-player__chrome input,\n.review-video-player--controls-visible .review-video-player__chrome select,\n.review-video-player--controls-visible .review-video-player__pose-tools,\n.review-video-player--controls-visible .review-video-player__joint-overlay,\n.review-video-player--controls-visible .review-video-player__transport,\n.review-video-player--controls-visible .review-video-player__game-points,\n.review-video-player__chrome:focus-within button,\n.review-video-player__chrome:focus-within input,\n.review-video-player__chrome:focus-within select,\n.review-video-player--top-collapsed .review-video-player__chrome-toggle {\n  pointer-events: auto;\n}\n\n.review-video-player--fullscreen:not(.review-video-player--controls-visible) .review-video-player__chrome,\n.review-video-player--fullscreen:not(.review-video-player--controls-visible).review-video-player--top-collapsed .review-video-player__chrome--top,\n.review-video-player--fullscreen:not(.review-video-player--controls-visible) .review-video-player__analysis-hud {\n  opacity: 0 !important;\n  pointer-events: none !important;\n}\n\n/* Match review basic playback: feedback icon stays tappable on the video. */\n.review-video-player.review-video-player--basic.review-video-player--has-feedback:not(.review-video-player--annotating) .review-video-player__analysis-hud {\n  opacity: 1 !important;\n  visibility: visible !important;\n  pointer-events: none;\n}\n\n.review-video-player--basic {\n  container-type: size;\n  container-name: review-basic;\n}\n\n.review-video-player--basic .review-video-player__chrome--bottom {\n  padding: clamp(4px, 1.6cqi, 12px);\n  padding-bottom: max(clamp(4px, 1.6cqi, 12px), env(safe-area-inset-bottom, 0px));\n}\n\n.review-video-player--basic .review-video-player__transport {\n  gap: clamp(4px, 1.2cqi, 8px);\n}\n\n.review-video-player--basic .review-video-player__transport-main > .review-video-player__btn,\n.review-video-player--basic .review-video-player__btn {\n  min-width: clamp(1.8rem, 9cqi, 3.1rem);\n  min-height: clamp(1.8rem, 9cqi, 3.1rem);\n  border-radius: clamp(8px, 2.4cqi, 14px);\n  padding: clamp(2px, 0.8cqi, 6px);\n}\n\n.review-video-player--basic .review-video-player__transport-main > .review-video-player__btn--play,\n.review-video-player--basic .review-video-player__btn--play {\n  min-width: clamp(2.1rem, 11cqi, 3.4rem);\n  min-height: clamp(2.1rem, 11cqi, 3.4rem);\n}\n\n.review-video-player--basic .review-video-player__btn svg {\n  width: clamp(12px, 4.2cqi, 22px);\n  height: clamp(12px, 4.2cqi, 22px);\n}\n\n.review-video-player--basic .review-video-player__btn span {\n  font-size: clamp(8px, 2.1cqi, 11px);\n}\n\n.review-video-player--basic .review-video-player__analysis-hud {\n  top: clamp(6px, 2cqi, 12px);\n  right: clamp(6px, 2cqi, 12px);\n  gap: clamp(4px, 1.4cqi, 8px);\n  max-width: min(78cqi, 18rem);\n}\n\n.review-video-player--basic .review-video-player__analysis-info-btn {\n  width: clamp(1.7rem, 8cqi, 2.75rem);\n  height: clamp(1.7rem, 8cqi, 2.75rem);\n}\n\n.review-video-player--basic .review-video-player__analysis-info-btn svg {\n  width: 48%;\n  height: 48%;\n}\n\n.review-video-player--basic .review-video-player__feedback-blink,\n.review-video-player--feedback-on-demand .review-video-player__feedback-blink {\n  animation: feedback-icon-blink 1.15s ease-in-out infinite;\n}\n\n.review-video-player--basic .review-video-player__feedback-blink.is-on,\n.review-video-player--feedback-on-demand .review-video-player__feedback-blink.is-on {\n  background: rgba(250, 204, 21, 0.42);\n  border-color: rgba(250, 204, 21, 0.9);\n}\n\n@keyframes feedback-icon-blink {\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 rgba(250, 204, 21, 0.75);\n  }\n  50% {\n    box-shadow: 0 0 0 clamp(3px, 1.4cqi, 8px) rgba(250, 204, 21, 0);\n  }\n}\n\n.review-video-player--basic .review-video-player__feedback-list {\n  width: min(72cqi, 16rem);\n  max-height: min(46cqi, 14rem);\n  overflow: auto;\n  padding: clamp(4px, 1.4cqi, 8px);\n  border-radius: clamp(8px, 2cqi, 12px);\n  background: rgba(15, 23, 42, 0.82);\n  pointer-events: auto;\n}\n\n.review-video-player--basic .review-video-player__feedback-play {\n  font-size: clamp(10px, 2.6cqi, 13px);\n}\n\n/* Embedded match review: hide HUD overlays until the coach taps. */\n.review-video-player:not(.review-video-player--controls-visible):not(.review-video-player--feedback-review):not(.review-video-player--feedback-recording):not(.review-video-player--annotating) .review-video-player__analysis-hud,\n.review-video-player:not(.review-video-player--controls-visible):not(.review-video-player--feedback-review) .review-video-player__chrome {\n  opacity: 0 !important;\n  pointer-events: none !important;\n}\n\n.review-video-player.review-video-player--basic.review-video-player--has-feedback:not(.review-video-player--annotating) .review-video-player__analysis-hud,\n.review-video-player.review-video-player--feedback-on-demand.review-video-player--has-feedback:not(.review-video-player--annotating) .review-video-player__analysis-hud {\n  opacity: 1 !important;\n  visibility: visible !important;\n  pointer-events: none;\n}\n\n.review-video-player--feedback-on-demand.review-video-player--has-feedback .review-video-player__feedback-blink,\n.review-video-player--feedback-on-demand.review-video-player--has-feedback .review-video-player__feedback-list {\n  pointer-events: auto !important;\n}\n\n.review-video-player--fullscreen:not(.review-video-player--controls-visible) .review-video-player__pose-tools,\n.review-video-player--fullscreen:not(.review-video-player--controls-visible) .review-video-player__analysis-hud * {\n  pointer-events: none !important;\n}\n\n.review-video-player--feedback-on-demand.review-video-player--has-feedback .review-video-player__feedback-blink,\n.review-video-player--fullscreen.review-video-player--feedback-on-demand.review-video-player--has-feedback .review-video-player__feedback-blink,\n.review-video-player--feedback-on-demand.review-video-player--has-feedback .review-video-player__feedback-list,\n.review-video-player--feedback-on-demand.review-video-player--has-feedback .review-video-player__feedback-list * {\n  pointer-events: auto !important;\n}\n\n/* Feedback take: only the review bar stays; hide transport / tools / HUD. */\n.review-video-player--feedback-review .review-video-player__chrome,\n.review-video-player--feedback-review .review-video-player__analysis-hud {\n  opacity: 0 !important;\n  visibility: hidden !important;\n  pointer-events: none !important;\n}\n\n.review-video-player--basic.review-video-player--feedback-review.review-video-player--has-feedback .review-video-player__analysis-hud,\n.review-video-player--feedback-on-demand.review-video-player--feedback-review.review-video-player--has-feedback .review-video-player__analysis-hud {\n  opacity: 1 !important;\n  visibility: visible !important;\n  pointer-events: none;\n}\n\n.review-video-player--feedback-review .review-video-player__feedback-mode {\n  pointer-events: auto;\n  bottom: max(16px, env(safe-area-inset-bottom, 0px));\n  gap: 10px;\n  padding: 8px 10px 8px 12px;\n  max-width: min(96%, 420px);\n}\n\n/* Keep pose tools clickable even if chrome visibility flickers */\n.review-video-player__pose-tools {\n  pointer-events: auto;\n}\n\n.review-video-player--embedded .review-video-player__chrome--top {\n  padding-right: 100px;\n  border-radius: 12px 12px 0 0;\n}\n\n.review-video-player__orient {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.review-video-player__chrome-toggle {\n  position: absolute;\n  top: max(10px, env(safe-area-inset-top, 0px));\n  right: 56px;\n  z-index: 2;\n  min-width: 40px;\n  min-height: 40px;\n  border-radius: 12px;\n  background: rgba(12, 16, 28, 0.72);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.28);\n}\n\n.review-video-player--embedded .review-video-player__chrome-toggle {\n  right: 52px;\n}\n\n.review-video-player--top-collapsed .review-video-player__chrome--top {\n  padding: 8px 56px 0 12px;\n  min-height: calc(max(10px, env(safe-area-inset-top, 0px)) + 44px);\n  background: transparent;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  gap: 0;\n}\n\n.review-video-player--top-collapsed .review-video-player__orient,\n.review-video-player--top-collapsed .review-video-player__pose-tools,\n.review-video-player--top-collapsed .review-video-player__orient-status {\n  display: none;\n}\n\n.review-video-player__orient-status {\n  margin: 0;\n  text-align: center;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.35;\n  color: rgba(255, 255, 255, 0.88);\n}\n\n.review-video-player__orient-status--error {\n  color: #ffb4b4;\n}\n\n.review-video-player__orient-status--ok {\n  color: #9be7b5;\n}\n\n.review-video-player__speeds {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n\n.review-video-player__speed-btn {\n  min-width: 44px;\n  height: 30px;\n  padding: 0 10px;\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 999px;\n  background: var(--review-btn-bg);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.review-video-player__speed-btn--active {\n  background: rgba(255, 255, 255, 0.88);\n  color: #111;\n  border-color: transparent;\n}\n\n.review-video-player__mute-btn {\n  min-width: 36px;\n  padding: 0 8px;\n}\n\n.review-video-player__mute-btn--on {\n  background: rgba(255, 255, 255, 0.22);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.review-video-player__joint-overlay {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\n.review-video-player__joint-overlay-players {\n  display: inline-flex;\n  gap: 4px;\n  margin-right: 2px;\n}\n\n.review-video-player__joint-overlay-btn {\n  min-width: 56px;\n  height: 28px;\n  padding: 0 10px;\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 999px;\n  background: var(--review-btn-bg);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n}\n\n.review-video-player__joint-overlay-players .review-video-player__joint-overlay-btn {\n  min-width: 36px;\n  padding: 0 8px;\n}\n\n.review-video-player__joint-overlay-btn--active {\n  background: rgba(255, 255, 255, 0.88);\n  color: #111;\n  border-color: transparent;\n}\n\n.review-video-player__joint-overlay-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.review-video-player__joint-overlay-error {\n  flex-basis: 100%;\n  margin: 0;\n  text-align: center;\n  color: #ffb4a9;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.review-video-player__joint-overlay-error-action {\n  display: inline;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: #fff;\n  font: inherit;\n  font-weight: 800;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.review-video-player--transport-locked .review-video-player__chrome--bottom {\n  opacity: 1;\n}\n\n.review-video-player--transport-locked .review-video-player__chrome--bottom button,\n.review-video-player--transport-locked .review-video-player__chrome--bottom input {\n  pointer-events: auto;\n}\n\n.review-video-player__scrubber-wrap {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.review-video-player__scrubber {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  height: 4px;\n  margin: 0;\n  accent-color: #fff;\n  cursor: pointer;\n}\n\n.review-video-player__time {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  color: rgba(255, 255, 255, 0.88);\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n  font-weight: 600;\n}\n\n.review-video-player__time-sep {\n  opacity: 0.55;\n}\n\n.review-video-player__transport {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 8px;\n  width: 100%;\n}\n\n.review-video-player__transport-main {\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n  gap: 6px;\n  width: 100%;\n}\n\n.review-video-player__transport-main > .review-video-player__btn {\n  flex: 1 1 0;\n  min-width: 0;\n  min-height: 52px;\n  padding: 6px 4px;\n  border-radius: 14px;\n}\n\n.review-video-player__transport-main > .review-video-player__btn--seek {\n  flex: 1.05 1 0;\n}\n\n.review-video-player__transport-main > .review-video-player__btn--frame {\n  flex: 0.95 1 0;\n}\n\n.review-video-player__transport-main > .review-video-player__btn--play {\n  flex: 1.25 1 0;\n  min-width: 56px;\n  min-height: 56px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.22);\n}\n\n.review-video-player__transport-extra {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.review-video-player__btn {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  min-width: 44px;\n  min-height: 44px;\n  padding: 4px 6px;\n  border: none;\n  border-radius: 12px;\n  background: var(--review-btn-bg);\n  color: #fff;\n  cursor: pointer;\n}\n\n.review-video-player__btn span {\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 1;\n  opacity: 0.85;\n}\n\n.review-video-player__btn--play {\n  min-width: 52px;\n  min-height: 52px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.review-video-player__btn--active {\n  background: rgba(255, 255, 255, 0.28);\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);\n}\n\n.review-video-player__btn:active {\n  transform: scale(0.96);\n}\n\n.review-video-player__ball-detector {\n  appearance: none;\n  -webkit-appearance: none;\n  font-size: 9px;\n  font-weight: 700;\n  text-align: center;\n  padding: 4px 8px;\n  max-width: 88px;\n}\n\n.review-video-player__ball-stroke {\n  appearance: none;\n  -webkit-appearance: none;\n  font-size: 9px;\n  font-weight: 700;\n  text-align: center;\n  padding: 4px 8px;\n  max-width: 118px;\n}\n\n.review-video-player__btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.review-video-player__reset-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  padding: 0 4px;\n}\n\n.review-video-player--landscape.review-video-player--fullscreen {\n  width: 100%;\n  height: 100%;\n}\n\n.review-video-player__save-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 25;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(0, 0, 0, 0.45);\n  pointer-events: auto;\n}\n\n.review-video-player__save-card {\n  width: min(360px, 100%);\n  padding: 16px 18px;\n  border-radius: 14px;\n  background: rgba(0, 0, 0, 0.62);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  color: #fff;\n  text-align: center;\n}\n\n.review-video-player__save-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.review-video-player__reencode-bar {\n  margin-top: 12px;\n  height: 6px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.18);\n  overflow: hidden;\n}\n\n.review-video-player__reencode-bar-fill {\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #0a84ff, #64d2ff);\n  transition: width 0.35s ease;\n}\n\n.review-video-player__reencode-meta {\n  margin: 8px 0 0;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: rgba(255, 255, 255, 0.82);\n}\n\n.review-video-player__hr {\n  position: absolute;\n  top: max(12px, env(safe-area-inset-top, 0px));\n  left: 12px;\n  z-index: 18;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  padding: 6px 10px;\n  border-radius: 10px;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  color: #fff;\n  pointer-events: none;\n  max-width: min(70vw, 280px);\n}\n\n.review-video-player__hr-line {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n}\n\n.review-video-player__hr-name {\n  font-size: 11px;\n  font-weight: 700;\n  opacity: 0.92;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 120px;\n}\n\n.review-video-player__hr-name::after {\n  content: \":\";\n}\n\n.review-video-player__hr-icon {\n  flex-shrink: 0;\n  color: #ff5a5f;\n}\n\n.review-video-player__hr-value {\n  font-size: 16px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n\n.review-video-player__hr-unit {\n  font-size: 11px;\n  font-weight: 600;\n  opacity: 0.85;\n  text-transform: lowercase;\n}\n\n.review-video-player__analysis-hud {\n  position: absolute;\n  /* Clear the fullscreen back button (44px) so it does not cover Show features. */\n  top: calc(max(12px, env(safe-area-inset-top, 0px)) + 72px);\n  right: max(12px, env(safe-area-inset-right, 0px));\n  left: auto;\n  bottom: auto;\n  /* Above chrome (20); still inside the player so the close \"X\" stays on top. */\n  z-index: 26;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n  max-width: min(86vw, 340px);\n  pointer-events: none;\n}\n\n.review-video-player__feedback-list {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n  max-height: 28vh;\n  overflow: auto;\n  pointer-events: auto;\n}\n\n.review-video-player__feedback-auto {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  width: min(86vw, 220px);\n  margin: 0;\n  padding: 6px 8px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  background: rgba(15, 23, 42, 0.78);\n  color: rgba(248, 250, 252, 0.96);\n  font-size: 11px;\n  font-weight: 650;\n  line-height: 1.3;\n  cursor: pointer;\n  user-select: none;\n}\n\n.review-video-player__feedback-auto input {\n  margin: 2px 0 0;\n  flex-shrink: 0;\n  accent-color: #facc15;\n}\n\n.review-video-player__feedback-hint {\n  width: min(86vw, 220px);\n  margin: 0;\n  padding: 0 4px;\n  font-size: 10px;\n  line-height: 1.35;\n  color: rgba(226, 232, 240, 0.78);\n  text-align: right;\n}\n\n.review-video-player__feedback-chip {\n  pointer-events: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  border: 1px solid rgba(250, 204, 21, 0.45);\n  border-radius: 999px;\n  padding: 2px 4px 2px 2px;\n  background: rgba(15, 23, 42, 0.82);\n  color: #fef9c3;\n}\n\n.review-video-player__feedback-play,\n.review-video-player__feedback-delete {\n  border: 0;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n}\n\n.review-video-player__feedback-play {\n  padding: 4px 6px 4px 8px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.review-video-player__feedback-delete {\n  width: 22px;\n  height: 22px;\n  display: grid;\n  place-items: center;\n  border-radius: 999px;\n}\n\n.review-video-player__feedback-delete:hover {\n  background: rgba(239, 68, 68, 0.85);\n  color: #fff;\n}\n\n.review-video-player__feedback-chip.is-on {\n  background: rgba(250, 204, 21, 0.28);\n  color: #fff;\n}\n\n.review-video-player__feedback-mode {\n  position: absolute;\n  top: auto;\n  bottom: calc(max(12px, env(safe-area-inset-bottom, 0px)) + 96px);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 40;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 8px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 750;\n  letter-spacing: 0.02em;\n  pointer-events: none;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n  max-width: min(96%, 26rem);\n}\n\n.review-video-player--annotating .review-video-player__feedback-mode {\n  bottom: calc(max(12px, env(safe-area-inset-bottom, 0px)) + 210px);\n}\n\n.review-video-player__feedback-mode--rec {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  background: rgba(127, 29, 29, 0.92);\n  color: #fecaca;\n  border: 1px solid rgba(248, 113, 113, 0.7);\n}\n\n.review-video-player__feedback-mode--review {\n  background: rgba(120, 53, 15, 0.92);\n  color: #fde68a;\n  border: 1px solid rgba(250, 204, 21, 0.7);\n}\n\n.review-video-player__feedback-mode--review.is-list-open {\n  border-radius: 16px;\n  padding: 8px 10px;\n}\n\n.review-video-player__feedback-mode-bar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.review-video-player__feedback-mode-label {\n  white-space: nowrap;\n}\n\n.review-video-player__feedback-mode-btn {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  min-height: 28px;\n  padding: 4px 10px;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.45);\n  color: inherit;\n  font: inherit;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n  pointer-events: auto;\n}\n\n.review-video-player__feedback-mode-btn.is-on {\n  background: rgba(250, 204, 21, 0.28);\n  border-color: rgba(250, 204, 21, 0.7);\n}\n\n.review-video-player__feedback-mode-btn--icon {\n  min-width: 28px;\n  padding: 4px 8px;\n  position: relative;\n}\n\n.review-video-player__feedback-mode-count {\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.review-video-player__feedback-mode-btn--primary {\n  background: rgba(250, 204, 21, 0.92);\n  border-color: transparent;\n  color: #422006;\n}\n\n.review-video-player__feedback-mode-btn:active {\n  transform: scale(0.97);\n}\n\n.review-video-player__feedback-mode-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-height: min(40vh, 14rem);\n  overflow: auto;\n  padding: 4px;\n  border-radius: 12px;\n  background: rgba(15, 23, 42, 0.55);\n  pointer-events: auto;\n}\n\n.review-video-player__feedback-mode-item {\n  appearance: none;\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 6px 10px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  color: #fde68a;\n  font: inherit;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n  pointer-events: auto;\n}\n\n.review-video-player__feedback-mode-item:hover,\n.review-video-player__feedback-mode-item.is-on {\n  background: rgba(250, 204, 21, 0.22);\n  border-color: rgba(250, 204, 21, 0.45);\n  color: #fff;\n}\n\n.review-video-player__feedback-mode-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: #ef4444;\n  box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7);\n  animation: feedback-rec-pulse 1.2s ease-out infinite;\n}\n\n@keyframes feedback-rec-pulse {\n  70% {\n    box-shadow: 0 0 0 8px rgba(239, 68, 68, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0);\n  }\n}\n\n.review-video-player--feedback-review {\n  box-shadow: inset 0 0 0 3px rgba(250, 204, 21, 0.85);\n}\n\n.review-video-player--feedback-recording {\n  box-shadow: inset 0 0 0 3px rgba(239, 68, 68, 0.9);\n}\n\n.review-video-player__feedback-demo {\n  position: absolute;\n  z-index: 8;\n  right: 12px;\n  bottom: 120px;\n  width: min(42%, 280px);\n  max-height: 36%;\n  border-radius: 12px;\n  background: #000;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);\n  pointer-events: none;\n}\n\n.review-video-player__analysis-info-btn {\n  pointer-events: auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  margin: 0;\n  padding: 0;\n  border: 1px solid rgba(255, 255, 255, 0.32);\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.62);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  color: rgba(255, 255, 255, 0.96);\n  cursor: pointer;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);\n  transition: transform 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    background 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    border-color 0.2s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.review-video-player__analysis-info-btn svg {\n  display: block;\n}\n\n.review-video-player__analysis-info-btn:hover {\n  transform: scale(1.04);\n  background: rgba(15, 23, 42, 0.82);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.review-video-player__analysis-info-btn:active {\n  transform: scale(0.96);\n}\n\n.review-video-player__analysis-info-btn.is-on,\n.review-video-player__analysis-info-btn[aria-pressed=\"true\"] {\n  background: rgba(250, 204, 21, 0.32);\n  border-color: rgba(250, 204, 21, 0.85);\n  color: #fff;\n}\n\n.review-video-player__analysis-info-btn:focus-visible {\n  outline: 2px solid rgba(125, 211, 252, 0.95);\n  outline-offset: 2px;\n}\n\n.review-video-player__analysis-hud--open .review-video-player__analysis-info-btn {\n  background: rgba(15, 23, 42, 0.88);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.review-video-player__analysis-hud-panel {\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: min(72vw, 260px);\n  max-width: min(86vw, 340px);\n  max-height: min(62vh, 420px);\n  overflow: auto;\n  padding: 10px 12px 12px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  background: rgba(15, 23, 42, 0.78);\n  backdrop-filter: blur(18px);\n  -webkit-backdrop-filter: blur(18px);\n  color: rgba(248, 250, 252, 0.96);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.38);\n  font-family: ui-sans-serif, system-ui, -apple-system, sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  text-align: left;\n}\n\n.review-video-player__analysis-hud-section + .review-video-player__analysis-hud-section {\n  padding-top: 8px;\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.review-video-player__analysis-hud-title {\n  margin-bottom: 4px;\n  color: rgba(186, 230, 253, 0.95);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.review-video-player__analysis-hud-row {\n  display: grid;\n  grid-template-columns: minmax(72px, 38%) 1fr;\n  gap: 8px;\n  align-items: baseline;\n}\n\n.review-video-player__analysis-hud-key {\n  color: rgba(226, 232, 240, 0.62);\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.review-video-player__analysis-hud-val {\n  color: rgba(248, 250, 252, 0.98);\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 11px;\n  font-weight: 600;\n  text-align: right;\n  overflow-wrap: anywhere;\n}\n\n.review-video-player__analysis-hud-line {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.review-video-player__analysis-hud-state {\n  margin-top: 2px;\n  padding: 1px 6px;\n  align-self: flex-end;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.14);\n  color: rgba(255, 235, 59, 0.95);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  font-size: 10px;\n}\n\n.review-video-player--embedded .review-video-player__analysis-hud {\n  top: max(12px, env(safe-area-inset-top, 0px));\n}\n\n.review-video-player__feedback-panel {\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: min(86vw, 220px);\n  max-height: min(42vh, 260px);\n  overflow: auto;\n  padding: 8px 10px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  background: rgba(15, 23, 42, 0.78);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);\n  color: rgba(248, 250, 252, 0.96);\n}\n\n.review-video-player__feedback-auto {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0;\n  font-size: 11px;\n  font-weight: 650;\n  line-height: 1.3;\n  cursor: pointer;\n  user-select: none;\n}\n\n.review-video-player__feedback-auto input {\n  margin: 2px 0 0;\n  flex-shrink: 0;\n  accent-color: #38bdf8;\n}\n\n.review-video-player__feedback-hint {\n  margin: 0;\n  font-size: 10px;\n  line-height: 1.35;\n  color: rgba(226, 232, 240, 0.78);\n}\n\n.review-video-player__feedback-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.review-video-player__feedback-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  margin: 0;\n  padding: 6px 8px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.06);\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.review-video-player__feedback-item:hover {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(255, 255, 255, 0.32);\n}\n\n.review-video-player__feedback-item.is-on {\n  background: rgba(56, 189, 248, 0.22);\n  border-color: rgba(125, 211, 252, 0.55);\n}\n\n.review-video-player__feedback-time {\n  flex-shrink: 0;\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n  font-size: 11px;\n  color: #7dd3fc;\n}\n\n.review-video-player__feedback-kind {\n  font-size: 11px;\n  line-height: 1.25;\n  color: rgba(248, 250, 252, 0.92);\n}\n\n/* --- viral clip composer modal --- */\n.review-video-player__clip-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: grid;\n  place-items: center;\n  padding: 20px;\n  background: rgba(8, 11, 16, 0.66);\n  backdrop-filter: blur(3px);\n  overflow-y: auto;\n}\n\n.review-video-player__clip-modal-inner {\n  width: min(920px, 100%);\n  max-height: 92vh;\n  overflow-y: auto;\n  background: #fff;\n  border-radius: 16px;\n  padding: 22px 24px 26px;\n  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
